import axios from 'axios';
import lstModules from 'common/json/lstModules.json';

var tokenid = localStorage.getItem("tokenid");
var httpURL = lstModules['main'].url + ":" + lstModules['main'].port;

export const getBooksUsageListSvc = (fromDt, toDt, callback) => {
    // console.log("getBooksUsageListSvc called, fromDt, toDt", fromDt, toDt);
    const formData = new FormData();
    formData.append("fromDt", fromDt);
    formData.append("toDt", toDt);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/library/book/usage',
        method: "POST",
        headers: { 'tokenid': tokenid },
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log('response in subjectTeacherListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstUsage = response.data.lstUsage;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}
